import { ButtonLoader } from "../Button"
import "./styles.scss"
import swal from 'sweetalert';

export const ExitWithoutSaving = ({ text, textButton, icon, onSave, }) => {

  return (
    <>
      <div className="alert">
        <div className="div-alert">
          <div className="line-alert">
            {icon}
            <div className="text-alert">{text}</div>
          </div>
          <ButtonLoader
            // isDisabled={selectedRows.length === 0}
            // loading={saving}
            messageProcess="Salvando"
            label={textButton}
            color="orange"
            handleClick={onSave}
          />
        </div>
      </div>
    </>
  )
}